module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "tips-body"
  }, _vm._l((_vm.tips), function(item) {
    return _c('li', [_c('dl', [_c('dt', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.text), function(subItem) {
      return _c('dd', [_c('span', [_vm._v(_vm._s(subItem.name))]), _vm._v(" "), (subItem.link) ? _c('router-link', {
        attrs: {
          "to": subItem.link
        }
      }, [_vm._v(_vm._s(subItem.desc))]) : _vm._e()], 1)
    })], 2)])
  })), _vm._v(" "), _c('button', {
    staticClass: "btn-square-primary btn-click-bg-change",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.finishClick()
      }
    }
  }, [_vm._v("完成")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips-header"
  }, [_c('i', {
    staticClass: "iconfont icon-mic"
  }), _vm._v("\n    对天猫精灵说“天猫精灵”，并说出以下指令：\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0bc5908"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/xiaofang/Tips/Index.vue
// module id = 927
// module chunks = 1